import { Pagination, Role, User } from '@interfaces';
import { DataListingRequest } from '@interfaces';

export type UsersState = Readonly<{
  loading: boolean;
  loadedUsersData: User[] | null;
  loadedUsersPagination: Pagination;
  errorMessage: string | null;
  foreignerBasicData: Partial<User> | null;
  employeeBasicData: Partial<User> | null;
  employeeTypes: Role[] | null;
  allRoles: Role[] | null;
  loadingEmployeeTypes: boolean;
  loadingAllRoles: boolean;
  loadingUsersTags: boolean;

  loadingDataListingRequest: boolean;
  dataListingRequests: DataListingRequest[] | null;

  reassignInProgress: boolean;
}>;

export const defaultPagination = {
  all: 0,
  limit: 25,
  offset: 0,
  orderBy: 'name',
  orderDir: 'asc',
};

export const initialState: UsersState = {
  loading: false,
  errorMessage: null,
  loadedUsersData: [],
  loadedUsersPagination: { ...(defaultPagination as Pagination) },
  foreignerBasicData: null,
  employeeBasicData: null,
  employeeTypes: null,
  allRoles: null,
  loadingEmployeeTypes: false,
  loadingAllRoles: false,
  loadingUsersTags: false,

  loadingDataListingRequest: false,
  dataListingRequests: null,

  reassignInProgress: false,
};
